import * as React from 'react';
import * as Yup from 'yup';
import {inject, observer} from 'mobx-react';
import {Formik, FormikProps} from 'formik';
import {Auth} from '../../models/authModel';
import BaseForm, {FormValues} from './private/BaseForm';

interface WithInjectedProps {
  auth: Auth;
}

@inject('auth')
@observer
export default class ForgotPasswordForm extends React.Component<{}, {}> {
  public render() {
    const loading = this._withInjectedProps.auth.isRequestingPasswordReset;

    return (
      <Formik
        initialValues={this._initialValues}
        validationSchema={this._validationSchema}
        onSubmit={this._handleSubmit}
        render={(props: FormikProps<FormValues>) => <BaseForm {...props} loading={loading} />}
      />
    );
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  private get _initialValues() {
    return {email: ''};
  }

  private get _validationSchema() {
    return Yup.object().shape({
      email: Yup.string()
        .email('E-mail is not valid.')
        .required('Please enter your email.')
    });
  }

  private _handleSubmit = ({email}: FormValues) => {
    this._withInjectedProps.auth.forgotPassword(email);
  };
}



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordForm/ForgotPasswordForm.tsx